import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import getAPIUrl from './helpers/getAPIUrl'

Vue.config.productionTip = false

// esperar a que se cargue conn.json antes de iniciar Vue
getAPIUrl()
  .then(url => {
    store.commit('setApiUrl', url)

    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  })
  .catch(err => {
    // eslint-disable-next-line no-console
    console.error('Error cargando connWeb.json:', err)
  })
